import { createSlice } from "@reduxjs/toolkit";

const aiInterviewSlice = createSlice({
    name: "aiInterview",
    initialState: {
        chunkData: { 'chunkIndex': 0, 'chunk': '' },
        jobTitle: '',
        userName: ''
    },
    reducers: {
        setChunkData: (state, action) => {
            state.chunkData = action.payload;
        },
        setJobTitle: (state, action) => {
            state.jobTitle = action.payload;
        },
        setUserName: (state, action) => {
            state.userName = action.payload;
        },
    },
});

export const {
    setChunkData,
    setJobTitle,
    setUserName
} = aiInterviewSlice.actions;

export default aiInterviewSlice.reducer;

export const selectChunkData = (state: {
    aiInterview: { chunkData: any };
}) => state.aiInterview.chunkData

export const selectJobTitle = (state: {
    aiInterview: { jobTitle: string };
}) => state.aiInterview.jobTitle

export const selectUserName = (state: {
    aiInterview: { userName: string };
}) => state.aiInterview.userName